module.exports = __webpack_public_path__ + "static/media/default-user.14e66dd4.svg";